import { useState } from 'react'
import { getImpersonation, clearImpersonation, stopImpersonating } from '../../lib/api'

/**
 * Always-visible bar shown while an operator is impersonating someone.
 *
 * Two things make this non-optional rather than a nicety. An impersonated
 * session looks exactly like an ordinary one, so without a persistent marker an
 * operator can forget whose account they are acting in and take a destructive
 * action believing it is their own. And the only way out is an API call — so
 * the exit has to live somewhere that is reachable from every page.
 */
export default function ImpersonationBanner() {
  const [busy, setBusy] = useState(false)
  const imp = getImpersonation()

  if (!imp) return null

  const stop = async () => {
    setBusy(true)
    try {
      await stopImpersonating()
    } catch {
      // Even if the call fails — expired token, revoked ability — dropping the
      // token locally is what actually returns the operator to their own
      // session. Staying stuck as someone else is the worse outcome.
    } finally {
      clearImpersonation()
      window.location.href = '/platform/users'
    }
  }

  return (
    <div
      className="flex items-center justify-center gap-3 px-4 py-2 text-xs font-semibold"
      style={{ background: '#F59E0B', color: '#1a1400' }}
      role="status"
    >
      <span>
        Impersonating <span className="font-bold">{imp.user?.name || 'a user'}</span>
        {imp.user?.email ? ` (${imp.user.email})` : ''} — actions are taken as them.
      </span>
      <button
        onClick={stop}
        disabled={busy}
        className="px-2.5 py-1 rounded-lg font-bold transition-opacity disabled:opacity-60"
        style={{ background: 'rgba(0,0,0,0.25)', color: '#fff' }}
      >
        {busy ? 'Stopping…' : 'Stop impersonating'}
      </button>
    </div>
  )
}
